export default "__VITE_ASSET__BAqi3CBJ__"